// extracted by css-extract-rspack-plugin
export default {"Header":"DeploymentRecordList-module__Header__qZihonH"};